export default {
    minutes: 'minute | minutes',
    hours: 'heure | heures',
    days: 'jours | jours',
    weeks: 'semaine | semaines',
    months: 'mois | mois',
    years: 'année | années',
    same_day: 'même jour | même jour',
    exact_time: 'date précise | date précise',

    abbreviations: {
        seconds: 's',
        minutes: 'm',
        hours: 'h',
        days: 'j',
    },
};
